import { useEffect, useState } from 'react';

const MOBILE_QUERY = '(max-width: 767px)';

/**
 * Returns `true` when the viewport is narrower than 768px (mobile breakpoint).
 * Updates reactively on window resize via MediaQueryList events.
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(MOBILE_QUERY).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const mql = window.matchMedia(MOBILE_QUERY);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);

    mql.addEventListener('change', handler);
    // Sync initial value in case it changed before the effect ran
    setIsMobile(mql.matches);

    return () => {
      mql.removeEventListener('change', handler);
    };
  }, []);

  return isMobile;
}
